import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Dumbbell, BarChart2, Settings, LogOut } from 'lucide-react';
import { useProfileStore } from '../../store/profileStore';
import { ThemeToggle } from '../ThemeToggle';

export function TrainerHeader() {
  const navigate = useNavigate();
  const { toggleTrainerMode } = useProfileStore();

  const navItems = [
    { icon: Users, label: 'Clients', path: '/trainer/clients' },
    { icon: Dumbbell, label: 'Workouts', path: '/trainer/workouts' },
    { icon: BarChart2, label: 'Analytics', path: '/trainer/analytics' },
    { icon: Settings, label: 'Settings', path: '/trainer/settings' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-40 h-16 bg-background/95 backdrop-blur-xl border-b border-border">
      <div className="container mx-auto h-full px-4">
        <div className="flex items-center justify-between h-full">
          <div className="flex items-center gap-8">
            <h1 className="text-xl font-bold">Trainer Dashboard</h1>
            <nav className="hidden md:flex items-center gap-6">
              {navItems.map((item) => (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  <item.icon className="w-4 h-4" />
                  {item.label}
                </button>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <ThemeToggle />
            <button
              onClick={() => toggleTrainerMode()}
              className="flex items-center gap-2 text-sm text-destructive hover:text-destructive/80 transition-colors"
            >
              <LogOut className="w-4 h-4" />
              Exit Trainer Mode
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}